<template>
  <div>
    <img style="width: 100%" src="../../assets/image/download/loc/index.jpg" alt="" />
    <header>
      <div class="card" v-if="inviteCode">
        我的邀请码
        <div>
          <span id="code">{{ inviteCode }}</span>
          <img
            @click="copy"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAyCAYAAAAJHRh4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkIzQ0Y4MTRDOEFENDExRUI4NEJBOUI0RDY0RjEyMzREIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkIzQ0Y4MTREOEFENDExRUI4NEJBOUI0RDY0RjEyMzREIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QjNDRjgxNEE4QUQ0MTFFQjg0QkE5QjRENjRGMTIzNEQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QjNDRjgxNEI4QUQ0MTFFQjg0QkE5QjRENjRGMTIzNEQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7h4pojAAACTUlEQVR42uyaQXKCQBBFkWIfbhC8Ad4AF1lHl67EE0RPkHgC4glk51KydhGPoCeQI3iCmO7YpijKaQkzDEimq7osLWR8M92/2xk6p9PJkrGn1Re+hOBLS5/twBfg8WZksxfaCgbzNMOh+TTmASZ4oAOwLsOx1wAZVQnYBJsC5LIqwC3lRN0WXgvXjiKR+ZlFcLdCgEfKPZ+55gjeBeE5Xj5wFP6Ad00rFYBHAlCXJvrtnnMQU6LPpMW4DSKDITgRKSukjdcGFcUVTG6VrnsvE3smT4uJDCw3Ji7K7zN9sQqlTCm3PphVKWX2DThUpAO1RYMKy4BH/eyaxgtU3dhhVu0CVUf79Qk+z8q9UkAawK85v17BH8BnSkOUGle/ISIylY0iJwfn0U2LFFsV5haYzEhGeJwrYcHVnTn0eYmgF5WBHBCIywhQrCJEQwaun4dT2JXE1H4di7RfpQBhJThpHmY79Ao7k9mtwi2zgqJ/5gnApZpEJaair2znoAjgXrNyVgbYSjOABtAAGkADaAANoAE0gAbQABrA/wm4Ff1JbxNgnN8V2IzsXWtCFGDwGK1nnTetevT+15w25Fl2xbgcFMXzWONvxX3R4I/5VlhkUsE1Hp0y6TDR8y6ptIrS1qDoRhFAhhrgQpWrdy0HF8wsLgESwxUPKVU+FxNQGnjMNQtVgCi5L8xggaXwcLKgJTITaufUCLfnhw0SSO5pinKdDEnupCFw3IFM+VYNIGMVN5ewHRVv6Vy3meKJytW1zmflukBTip6eTGnI2rcAAwBkDpfR9z0xCgAAAABJRU5ErkJggg=="
          />
        </div>
      </div>
      <button class="headerButton" @click="downloadApp">立即下载</button>
    </header>
    <section class="mask">
      <img src="../../assets/image/download/mask.png" />
    </section>
    <footer>
      <button class="footerButton" @click="downloadApp">立即下载</button>
    </footer>
  </div>
</template>
<script>
import { track, downloadApp as download, showToast } from "./common";

const ANDROID_PACKAGE = "com.eletell.lightenchild";

export default {
  data() {
    return {
      inviteCode: "",
    };
  },
  methods: {
    downloadApp() {
      download({
        trackPageId: 2021030404,
        iosUrl:
          "https://apps.apple.com/cn/app/%E6%9C%AA%E6%9D%A5%E4%B9%8B%E5%85%89-%E5%84%BF%E7%AB%A5/id1499779043",
        androidPackage: ANDROID_PACKAGE,
      });
    },
    fetchInviteCode() {
      const urlParams = new URLSearchParams(window.location.search);
      const userId = urlParams.get("id");
      // 没有 url 邀请码参数，则不展示邀请码卡片
      if (!userId) return;

      fetch("https://api2.kid.eletell.com/gate/active/getUserInviteCode", {
        method: "POST",
        body: new URLSearchParams({ userId, activeId: 1 }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 1) {
            track(2021030403);
            this.inviteCode = data.result.inviteCode;
          }
        });
    },
    copy() {
      if (!this.inviteCode) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(this.inviteCode)
          .then(() => {
            showToast("复制成功");
          })
          .catch((err) => {
            console.error("复制失败", err);
            showToast("复制失败，请重试");
          });
      } else {
        showToast("该浏览器不支持自动复制");
      }
    },
  },
  mounted() {
    this.fetchInviteCode();
  },
};
</script>
<style>
body {
  position: relative;
  margin: 0;
}
img {
  display: block;
}
button {
  border-radius: 9999px;
  border: none;
  font-weight: 700;
}
header {
  position: absolute;
  top: 5.14%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.headerButton {
  width: 40.27vw;
  height: 9.8vw;
  font-size: 3.7vw;
  background-color: #ffca2b;
  color: #fff;
}
footer {
  position: absolute;
  bottom: 3.06%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.footerButton {
  width: 71.3vw;
  height: 13vw;
  font-size: 4.6vw;
  background-color: #fff;
  color: #44a6fd;
}
.mask {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.mask img {
  position: absolute;
  top: 2vw;
  right: 2vw;
  width: 75%;
}
.card {
  width: 86%;
  padding: 4.6vw 0 9.2vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 20px;
  font-size: 3.33vw;
  color: #333;
  line-height: 1em;
  margin-bottom: 9vw;
}
.card > div {
  margin-top: 6vw;
  display: flex;
  align-items: baseline;
  color: #44a6fd;
  font-size: 9.2vw;
  font-weight: bold;
  line-height: 1em;
}
.card img {
  width: 5.2vw;
  margin-left: 2.8vw;
}
</style>
